import Vue from 'vue';
import logger from '@/utils/logger';
import { getApp } from '@/utils/util';
import { checkEnv } from '@/utils/browser-env';

let ua = '';
let clientVersion = '';

const MORE_FLAG = 1;
const EQUAL_FLAG = 0;
const LESS_FLAG = -1;

let logIndex = 0; // 记录打印
let isGetUserAgentLoading = false; // 用来标识是否加载中
const loadingPromiseList = [];

const platform = Vue.Native ? Vue.Native.Platform : 'browser';

// 获取UA
export const getUserAgent = () => new Promise((resolve, reject) => {
  const x = logIndex;
  logIndex += 1;
  if (ua) {
    logger.debug(`getUserAgent cache user-agent:${ua}`);
    resolve(ua);
  } else if (isGetUserAgentLoading) {
    // 等待返回再resolve
    logger.debug(`getUserAgent waiting id:${x}`);
    loadingPromiseList.push({ resolve, reject });
  } else {
    let uaFlag = false;
    const userAgent = getApp()?.$options?.$superProps?.httpHeaderInfo?.['User-Agent'];
    if (userAgent) {
      resolve(userAgent);
    } else {
      setTimeout(() => {
        if (!uaFlag) {
          logger.error(`native timeout from 2000ms: getHttpHeader id:${x}`);
          const err = new Error({
            msg: 'native timeout',
          });
          reject(err);
          while (loadingPromiseList.length > 0) {
            const { reject } = loadingPromiseList.pop();
            reject(err);
          }
        } else {
          //
        }
      }, 2000);
      logger.debug(`getUserAgent callNativeWithPromise id:${x}`);
      isGetUserAgentLoading = true;
      Vue.Jsbridge.getHttpHeader()
        .then((data) => {
          isGetUserAgentLoading = false;
          logger.debug(`getUserAgent callNativeWithPromise response!!! id:${x}`, data);
          uaFlag = true;
          ua = data.userAgent;
          resolve(ua);
          while (loadingPromiseList.length > 0) {
            const { resolve } = loadingPromiseList.pop();
            resolve(ua);
          }
        })
        .catch((err) => {
          isGetUserAgentLoading = false;
          uaFlag = true;
          logger.debug(`getUserAgent callNativeWithPromise error!!! id:${x}`, err);
          reject(err);
          while (loadingPromiseList.length > 0) {
            const { reject } = loadingPromiseList.pop();
            reject(err);
          }
        });
    }
  }
});

// 获取终端版本号
export const getClientVersion = (ua) => {
  if (clientVersion) {
    return clientVersion;
  }
  let isAndroid = platform === 'android';
  let isIOS = platform === 'ios';
  if (platform === 'browser') {
    const env = checkEnv();
    isAndroid = env.android;
    isIOS = env.ios;
  }
  if (isAndroid) {
    clientVersion = getAndroidVersion(ua);
  }
  if (isIOS) {
    clientVersion = getIOSVersion(ua);
  }
  return clientVersion;
};

// 获取IOS版本号
const getIOSVersion = (ua) => {
  if (!ua) return '';
  console.log(ua);
  // eslint-disable-next-line max-len
  // ua = 'Mozilla/5.0 (iPhone; CPU iPhone OS 13_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 com.tencent.gamecommunity/1.1.0.1.1.1sss ENV/TEST SUB/0 Scale/2.00'
  return ua.replace(/.*\s+com\.tencent\.gamecommunity\/(\S+)\s+.*/ig, '$1').replace(/([^\d.])/g, '');
};

// 获取Android版本号
const getAndroidVersion = (ua) => {
  if (!ua) return '';
  // ua = 'ENV/TEST BUNDLEID/com.tencent.gamecommunity CHANNEL/DevOps VERSION_NAME/1.1.0.2 VERSION_CODE/2 SUB/0'
  return ua.replace(/.*\s+VERSION_NAME\/(\S+)\s+.*/ig, '$1').replace(/([^\d.])/g, '');
};

// 对比版本
export const compareVersion = (targetVersion, currentVersion) => {
  // 没有当前版本直接按照小于处理
  if (!currentVersion) {
    return LESS_FLAG;
  }
  const nowVersion = currentVersion;
  // targetVersion = '1.0.1.1'
  // nowVersion = '1.0.1.2.3'
  const tvr = targetVersion.split('.');
  const nvr = nowVersion.split('.');
  // console.log(tvr)
  // console.log(nvr)
  let status = EQUAL_FLAG;
  // 任何一个版本号解析错误都按照小于
  if (tvr.length <= 0 || nvr.length <= 0) {
    status = LESS_FLAG;
  } else {
    // 循环对比
    for (let i = 0; i < nvr.length; i++) {
      const n = parseInt(nvr[i], 10);
      let t = tvr[i];
      // console.log(n)
      // 如果当前版本位数大于目标版本
      if (typeof t === 'undefined') {
        if (n > 0) {
          status = MORE_FLAG;
        } else {
          status = EQUAL_FLAG;
        }
      } else {
        t = parseInt(tvr[i], 10);
        if (n > t) {
          status = MORE_FLAG;
          break;
        } else if (n === t) {
          status = EQUAL_FLAG;
        } else {
          status = LESS_FLAG;
          break;
        }
      }
    }
    // 如果当前版本位数小于目标版本并且前面没对比出来大小
    if (status === EQUAL_FLAG && tvr.length > nvr.length) {
      // console.log(111111111)
      let nl = nvr.length;
      while (typeof tvr[nl] !== 'undefined') {
        // console.log(`while: ${tvr[nl]}`)
        status = parseInt(tvr[nl], 10) > 0 ? LESS_FLAG : EQUAL_FLAG;
        nl += 1;
      }
    }
  }
  return status;
};

/**
 * 判断目标版本是否大于当前版本
 * @param targetVersion [String|Object] 安卓IOS统一对比就传字符串 分开对比就传对象 {android: '1.1.0', ios: '1.1.0',}
 * @returns {Promise} code -1 当前版本小于目标版本 0 当前版本等于目标版本 1 当前版本大于目标版本 ua userAgent currentVersion 当前版本号
 */
export default async function (targetVersion) {
  let code = LESS_FLAG;
  let ua = '';
  let currentVersion = '';
  try {
    ua = await getUserAgent();
    currentVersion = getClientVersion(ua);
    if (typeof targetVersion === 'string') {
      code = compareVersion(targetVersion, currentVersion);
    } else if (typeof targetVersion === 'object') {
      code = compareVersion(targetVersion[platform], currentVersion);
    }
  } catch (e) {
    //
  }
  logger.debug('compareVersion', {
    code,
    targetVersion,
    currentVersion,
    ua,
  });
  return {
    code,
    targetVersion,
    currentVersion,
    ua,
  };
}
